import { render, staticRenderFns } from "./listInclusion.vue?vue&type=template&id=6f12dd9c&"
import script from "./listInclusion.vue?vue&type=script&lang=js&"
export * from "./listInclusion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports